import { Box, Button } from '@mui/material';

import { convertLogscaleLinks } from '@/utils/Common.utils';

import LogscaleSvgIcon from '../LogscaleSvgIcon';

export const LogScaleButton = () => {
  return (
    <Button
      variant="twoTone"
      aria-label="notifications"
      sx={{ py: 0.5, px: 1.5 }}
      href={convertLogscaleLinks('https://events.pondurance.com/')}
      target="_blank"
    >
      <LogscaleSvgIcon />
      <Box sx={{ ml: 1 }}>Logs</Box>
    </Button>
  );
};

export default LogScaleButton;
